<form
	(ngSubmit)="searchByInstrument(searchByInstrumentForm)"
	#searchByInstrumentForm="ngForm"
	class="flex items-center"
	[@openCloseWithState]="showSearchSection ? 'open' : 'closed'"
	id="teranetForm"
>
	<div class="flex pb-2">
		<div class="flex">
			<app-input
				[(ngModel)]="instrumentId"
				name="instrumentId"
				[required]="true"
				[submitted]="submitted"
				label="Instrument number"
				[testHook]="testHooks.InstrumentNumber"
			></app-input>
		</div>
		<div class="flex items-end">
			<ui-button
				class="ml-5 mb-1"
				preset="HIGH_EMPHASIS"
				type="submit"
				teranetLoginGuard
				label="Search"
				[testHook]="testHooks.SearchButton"
			>
			</ui-button>
		</div>
	</div>
</form>

<app-pins-table
	[pins]="pins"
	[searching]="searchingPins"
	[isOverview]="isOverview"
	[error]="error"
	[name]="instrumentId"
></app-pins-table>
